/* eslint-disable import/no-default-export */
import PropTypes from 'prop-types';
import React from 'react';

// eslint-disable-next-line no-restricted-imports
import { CommentDataModel } from 'types';

// eslint-disable-next-line no-restricted-imports
import { TrelloMarkdownWrapper } from 'util/trello-markdown-config';

import styles from './trello-markdown.less';

export enum MarkdownContentType {
  Comment,
  Description,
  PowerUpDescription,
  CheckItems,
}

interface AllProps {
  text: string;
  contentType: MarkdownContentType;
  options?: CommentDataModel;
}

export const MarkdownContext = React.createContext<TrelloMarkdownWrapper | null>(
  null,
);

class MarkdownContainer extends React.Component<AllProps> {
  static contextTypes = {
    store: PropTypes.object,
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: AllProps, context: { store: any }) {
    super(props);
  }

  formatComment(markdown: TrelloMarkdownWrapper) {
    return markdown.comments.format(this.props.text, {
      siteDomain: window.siteDomain,
      ...this.props.options,
    }).output;
  }

  formatPowerUpDescription(markdown: TrelloMarkdownWrapper) {
    return markdown.powerUpDescription.format(this.props.text).output;
  }

  formatCheckItems(markdown: TrelloMarkdownWrapper) {
    return markdown.checkItems.format(this.props.text).output;
  }

  render() {
    return (
      <MarkdownContext.Consumer>
        {(markdown) => {
          let formattedContent: string;

          if (!markdown) {
            throw new Error('MarkdownContext not provided');
          }

          switch (this.props.contentType) {
            case MarkdownContentType.Comment:
              formattedContent = this.formatComment(markdown);
              break;
            case MarkdownContentType.PowerUpDescription:
              formattedContent = this.formatPowerUpDescription(markdown);
              break;
            case MarkdownContentType.CheckItems:
              formattedContent = this.formatCheckItems(markdown);
              break;
            default:
              throw new Error(
                'Invalid MarkdownContentType for MarkdownContainer.',
              );
          }

          return (
            // tslint:disable-next-line:react-no-dangerous-html
            <div
              className={styles.markdown}
              dangerouslySetInnerHTML={{
                __html: formattedContent,
              }}
            />
          );
        }}
      </MarkdownContext.Consumer>
    );
  }
}

export default MarkdownContainer;



// WEBPACK FOOTER //
// ./app/gamma/src/components/trello-markdown/index.tsx